<template>
  <el-dialog
    class="rc-dialog"
    :title="importInfo.title"
    :visible.sync="importInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item>
        <butn btntype="primary" title="下载模板" @click="downloadTemplate"></butn>
      </el-form-item>
      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="file == null"
      >
        <upload v-model="file" ref="removeFile" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { importTopicLecture } from "@/api/topicLecture";
import Upload from "@/components/upload/excel";
import {
  topicLectureTemplate,
} from "@/assets/excel/index.js";
import { downloadByUrl } from "../../../utils/common";

export default {
  components: { butn, Upload },
  props: {
    importInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          title: "导入",
          nowType: 0,
        };
      },
    },
  },
  data() {
    return {
      classId: "",
      file: null,
      EXCP: topicLectureTemplate,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeImport");
    },
    downloadTemplate() {
      downloadByUrl("", this.EXCP)
    },
    createData() {
      if (this.file != null) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        let api = importTopicLecture;

        api(formData).then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            if (res.data != null) {
              this.$message.error("导入包含错误数据，请检查");
              this.$router.push({
                path: "/excelError",
              });
              localStorage.setItem("errorExcelData", JSON.stringify(res.data));
              this.closeDialog();
            } else {
              this.$message.success(res.msg);
              this.closeDialog();
            }
          } else {
            this.$refs.removeFile.$refs.upload.uploadFiles.pop();
            this.file = null;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
